import * as React from 'react';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { CnFormItem } from '@/components/cn-form-item';
import { CnTimePickerPro } from '@/components/cn-time-picker-pro';
import isFunction from 'lodash/isFunction';
import { isValidDate } from '@/utils/date';
export default function CalendarTimePicker(props) {
    const { prefix, label, value, format = 'HH:mm:ss', onChange, ...others } = props;
    const [curTime, setTime] = useState(isValidDate(value) ? value : new Date());
    const clsPrefix = `${prefix}-time`;
    useEffect(() => {
        if (isValidDate(value)) {
            setTime(value);
        }
    }, [value]);
    /**
     * 处理 time picker 调整事件
     * @param date
     */
    const handlePickerChange = (date) => {
        const d = dayjs(date);
        const h = d.hour();
        const m = d.minute();
        const s = d.second();
        const newDate = dayjs(curTime).hour(h).minute(m).second(s);
        // setTime(newDate.toDate());
        // 当关闭时, 触发 change 回调
        if (isFunction(onChange)) {
            onChange(newDate.toDate());
        }
    };
    return (React.createElement("div", { className: clsPrefix },
        React.createElement(CnFormItem, { title: label },
            React.createElement(CnTimePickerPro, { ...others, insideForm: true, formLabel: label, className: `${clsPrefix}-picker`, format: format, value: curTime, onChange: handlePickerChange }))));
}
